import React, { useContext, useState, useEffect, useRef } from 'react';
import { useQuery, useMutation } from '@apollo/client';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import CommentIcon from '@icons/editor/comment-icon';
import AddDocIcon from '@icons/editor/add-doc-icon';
import TrashIcon from '@icons/editor/trash-icon';
import DropdownIcon from '@icons/editor/dropdown-icon';

import { CommentText, DropdownContainer, DropdownButton, Dropdown, DropdownItem, Wrapper, WrapperLoad, StyledHeader, StyledBody, StyledBodyLoad, AddCard, DocCard, DocItem, Text, TextBlock, IconBlock } from './editor-comment.styles';
import { GET_ELIB_COMMENT_DATA, GET_ELIB_COMMENT_CREATE, GET_ELIB_COMMENT_UPDATE, GET_ELIB_COMMENT_DELETE } from '@graphql/editor';

const EditorComments = () => {
  const [state, dispatch] = useContext(Context);
  const { loading, error, data, refetch } = useQuery(GET_ELIB_COMMENT_DATA, { variables: { first: 100, page: 1 } });
  const [createDoc, { data:createData, loading:createLoading, error:createError }] = useMutation(GET_ELIB_COMMENT_CREATE);
  const [updateDoc, { data:updateData, loading:updateLoading, error:updateError }] = useMutation(GET_ELIB_COMMENT_UPDATE);
  const [deleteDoc, { data:deleteData, loading:deleteLoading, error:deleteError }] = useMutation(GET_ELIB_COMMENT_DELETE);

  const deleteSubmit = (id) => {
    deleteDoc({
      variables: {
        id: `${id}`
      }
    })
  };

  const updateSubmit = ({id, title, content}) => {
    updateDoc({
      variables: {
        id: `${id}`,
        content: `${content}`
      }
    })
  };

  const createSubmit = () => {
    const date = new Date().toLocaleString();
    createDoc({
      variables: {
        title: 'Новый документ ' + date,
        content: '',
      }
    }).then((res) => {
      dispatch({ type: 'TOGGLE_EDITOR_NEW_DOC_MODAL', edit_doc: res?.data?.elibReaderCommentCreate?.id });
    })
  };

  useEffect(() => {
    refetch()
  }, [state.isEditorCommentsSidebarOpened, data, deleteData]);

  if (loading || createLoading || deleteLoading)
    return (
      <div
        style={{ display: state.isEditorCommentsSidebarOpened ? 'block' : 'none' }}
      >
        <Wrapper>
          <StyledHeader>
            Комментарии
          </StyledHeader>
          <StyledBodyLoad>
            <p>Загрузка</p>
          </StyledBodyLoad>
        </Wrapper>
      </div>
    );

  if (error || createError || deleteError)
    return (
      <div
        style={{ display: state.isEditorCommentsSidebarOpened ? 'block' : 'none' }}
      >
        <Wrapper>
          <StyledHeader>
            Комментарии
          </StyledHeader>
          <StyledBodyLoad>
            <p>Ошибка: {error.message}</p>
          </StyledBodyLoad>
        </Wrapper>
      </div>
    );

  return (
    <div
      style={{ display: state.isEditorCommentsSidebarOpened ? 'block' : 'none' }}
    >
      <Wrapper>
        <StyledHeader>
          Комментарии
        </StyledHeader>
        <StyledBody>
            {data?.elibReaderCommentData?.data?.map(item => (
              <DocCard>
                <div onClick={() => {
                    dispatch({ type: 'TOGGLE_EDITOR_NEW_DOC_MODAL', edit_doc: item.id });
                  }}
                  title="Выбрать документ"
                >
                  <DocItem>
                    <IconBlock>
                      <CommentIcon width="25px" height="25px"/>
                    </IconBlock>
                    <TextBlock>
                      <div>
                        <Text>Александр Чемезов</Text>
                        <Text>{item.created_at}</Text>
                      </div>
                    </TextBlock>
                  </DocItem>
                  <CommentText>
                    <div dangerouslySetInnerHTML={{__html: item.content}}/>
                  </CommentText>
                </div>
                <DropdownList delete={deleteSubmit} update={updateSubmit} item={item}/>
              </DocCard>
            ))}
        </StyledBody>
      </Wrapper>
    </div>
  );
};

const DropdownList = (props) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const wrapperRef = useRef();
  useOnClickOutside(wrapperRef, () => setDropdownActive(false));

  return (
      <DropdownContainer ref={wrapperRef}>
        <DropdownButton onClick={() => setDropdownActive(!dropdownActive)}>
          <DropdownIcon width="30px" height="30px"/>
        </DropdownButton>
        <Dropdown style={{ display: dropdownActive ? 'block' : 'none' }}>
          <DropdownItem onClick={() => {
            props.delete(props.item.id);
          }}>
            <TrashIcon width="30px" height="20px"/> Удалить
          </DropdownItem>
        </Dropdown>
      </DropdownContainer>
  );
};

function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}


export default EditorComments;
